import React, { useEffect, useState } from "react";
import { imgFor, isLoaded, markLoaded } from "../../data/casesData";
import { Loader2 } from "lucide-react";

// Renders a real product photo for the item with a smooth loading swirl,
// fading the image in once loaded. If the image was already preloaded
// elsewhere it renders instantly (no swirl). Falls back to the icon on error.
export default function ItemImage({ item, imgClass = "", iconClass = "", color, eager = false }) {
  const src = item ? imgFor(item.name) : "";
  const [err, setErr] = useState(false);
  const [loaded, setLoaded] = useState(() => isLoaded(src));

  useEffect(() => { setErr(false); setLoaded(isLoaded(src)); }, [src]);

  if (!item) return null;
  const Icon = item.icon;
  if (err) return Icon ? <Icon className={iconClass} style={{ color }} /> : null;

  return (
    <span className={`relative inline-flex items-center justify-center overflow-hidden ${imgClass}`}>
      {!loaded && <Loader2 className="absolute h-4 w-4 animate-spin" style={{ color: color || "#C4C9D4" }} />}
      <img
        src={src}
        alt={item.name}
        loading={eager ? "eager" : "lazy"}
        decoding="async"
        onLoad={() => { markLoaded(src); setLoaded(true); }}
        onError={() => { markLoaded(src); setErr(true); }}
        className={`h-full w-full object-contain transition-opacity duration-300 ${loaded ? "opacity-100" : "opacity-0"}`}
      />
    </span>
  );
}
